// extracted by mini-css-extract-plugin
export default {"catCard":"CatCard_catCard__NjowU","catCard__image":"CatCard_catCard__image__QU3V-","catCard__name":"CatCard_catCard__name__qcs9k"};